// extracted by mini-css-extract-plugin
export default {"annotations":"Annotations_annotations__cSL7s","annotationsContent":"Annotations_annotationsContent__tGN-I","likeAnimation":"Annotations_likeAnimation__mHdxe"};